<template>
    <p class="error">You have not selected any topic</p>
</template>

<style lang="sass">

    .error
        color: indianred
        text-align: center
        font-size: 1.2rem

</style>